import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsPricingPage } from 'types/cms/single-types'

/**
 * Get the pricing page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsPricingPage | undefined>}
 */
const getPricingPage = async (locale: Language = Language.DUTCH): Promise<CmsPricingPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsPricingPage>>(`${process.env.CMS_API_URL}/pricing-v2?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getPricingPage
